import * as React from "react";
import { cva } from "class-variance-authority";
import { cn } from "@/lib/utils";
import { useI18n } from "@/contexts/I18nContext";

const badgeVariants = cva(
  "inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default:
          "border-transparent bg-primary text-primary-foreground hover:bg-primary/80",
        secondary:
          "border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80",
        destructive:
          "border-transparent bg-destructive text-destructive-foreground hover:bg-destructive/80",
        outline: "text-foreground",
        success:
          "border-transparent bg-green-100 text-green-800 hover:bg-green-200 dark:bg-green-900/20 dark:text-green-400",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
);

function Badge({ className, variant, children, ...props }) {
  const { translateText } = useI18n();
  return (
    <div className={cn(badgeVariants({ variant }), className)} {...props}>
      {typeof children === "string" ? translateText(children) : children}
    </div>
  );
}

export { Badge, badgeVariants };
